import { Component, computed, input, model } from "@angular/core"
import { NgClass, UpperCasePipe } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { FormValueControl } from "@angular/forms/signals"
import { Iso3166alpha2 } from "src/app/helpers/ISO3166CountryCodes"
import { CountriesDropdownComponent } from "../countries-dropdown/countries-dropdown.component"
import { RichTextEditorComponent } from "../rich-text-editor/rich-text-editor.component"
import { MatIcon } from "@angular/material/icon"


@Component({
    selector: "valben-dictionary-input",
    templateUrl: "./dictionary-input.component.html",
    standalone: true,
    imports: [NgClass, UpperCasePipe, FormsModule, CountriesDropdownComponent, RichTextEditorComponent, MatIcon],
})
export class DictionaryInputComponent implements FormValueControl<{ [lang: string]: string }> {
    value = model.required<{ [lang: string]: string }>()
    title = input("")
    textArea = input(false)
    richText = input(false)
    error = input(false)
    invalid = input(false)

    hasError = computed(() => this.error() || this.invalid())

    langs = computed(() => Object.keys(this.value()))
    availableCountries = computed(() => Iso3166alpha2.getFormated().filter(c => !(c.code in this.value())))

    
    step: "idle" | "pickLang" | "enterText" = "idle"
    selectedCountry: string | null = null
    selectedCountryName: string = ""
    inputedValue: string = ""

    setLang(lang: string, text: string): void {
        this.value.update(v => ({ ...v, [lang]: text }))
    }

    removeLang(lang: string): void {
        this.value.update(v => {
            const copy = { ...v }
            delete copy[lang]
            return copy
        })
    }

    startAdd(): void {
        this.step = "pickLang"
    }

    cancelAdd(): void {
        this.step = "idle"
        this.selectedCountry = null
        this.selectedCountryName = ""
        this.inputedValue = ""
    }

    selectCountry(result: { code: string }): void {
        if (this.richText() && this.textArea()) {
            this.setLang(result.code, "")
            this.cancelAdd()
            return
        }
        this.selectedCountry = result.code
        this.selectedCountryName = Iso3166alpha2.getCountryName(result.code)
        this.step = "enterText"
    }

    confirmAdd(): void {
        if (this.selectedCountry) {
            this.setLang(this.selectedCountry, this.inputedValue)
        }
        this.cancelAdd()
    }
}
